import FrequentlyAskedQuestionComponent from "../FrequentlyAskedQuestion/FrequentlyAskedQuestionComponent";
import TestimonialComponent from "../Testimonial/TestimonialComponent";
import CoursesWithSubscription from "../UsefulEntity/CoursesWithSubscription";
import LpWithSubscription from "../UsefulEntity/LpWithSubscription";
import SubscriptionInfoBannerComponent from "./SubscriptionInfoBanner/SubscriptionInfoBannerComponent";
import SubscriptionMainBanner from "./SubscriptionMainBanner/SubscriptionMainBanner";
import SubscriptionPriceSectionComponent from "./SubscriptionPriceSection/SubscriptionPriceSectionComponent";
import "./SubscriptionSectionComponent.scss";

const SubscriptionSectionComponent = (props) => {

  return (
    <>
      <SubscriptionInfoBannerComponent />
      <SubscriptionMainBanner />
      <SubscriptionPriceSectionComponent {...props} />
      <CoursesWithSubscription fetchData={true} is_home={false} from_sub={true}/>
      <LpWithSubscription />
      <TestimonialComponent />
      <FrequentlyAskedQuestionComponent />
    </>
  );
};

export default SubscriptionSectionComponent;
